
/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Row, Col, Image, Space, Modal } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { countLineHead } from '../../../../../../config/constant';
import { TableCell, TableRow, Button, TextField, Checkbox } from "@mui/material";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import { toast } from 'react-toastify';
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { getBusinessId } from "../../../../../../helpers/utilities";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../../helpers/validation";
import { getRequest } from '../../../../../../helpers/axiosClient';
import { exportCommonFile } from '../../../../../../helpers/utilities';
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { RunQuery } from "./RunQuery";
import { LineForm } from "./LineForm";


const searchTypes = [
    { id: 'name', label: "Name" },
    { id: 'code', label: "Code" },
    { id: 'both', label: "Both" },
    { id: 'standard', label: "Standard" },
    { id: 'mrp', label: "MRP" }
];

export const LinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, form, lines, getColumnWidth, unitMesurementdetails, changeHandlerLine, handleBulkDelete, batch,
        currencyFormat, dispatch, productActions, idNamingConversion, productGroupApi, setBatch,
        lineSubmit, deleteLine, headerView, useEventListener, locationDetails, productApi, search, setSearch, createProduct,
        searchType, changeSearchType, customObject
    } = props;
    const priceRef = useRef(null);
    const addLineRef = useRef(null);
    const [filterForm, setFilterForm] = useState({});
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [visible, setVisible] = useState(false);
    const [filterVisible, setFilterVisible] = useState(false);
    const [title, setTitle] = useState('Add');

    const [lineId, setLineId] = useState('');
    const [view, setView] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [lineName, setLineName] = useState('');
    const [units, setUnits] = useState([]);
    const [selected, setSelected] = useState([]);

    const [iconAnimation, setIconAnimation] = useState(false);

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        setLineForm({
            lineNumber: parseInt(lines?.length + 1),
        });
        productApi();
        setLineId('');
        setLineError({});
        setBatch([]);
    }

    useImperativeHandle(ref, () => ({
        getVisible() {
            return visible
        },
        handleLineSubmit(e) {
            handleLineSubmit(e)
        },
        handleUnits(d) {
            return handleUnits(d)
        },
        handleBulkUnits(ids) {
            handleBulkUnits(ids)
        },
        handleSelected(ids) {
            setSelected(ids);
        },
        handleFilterForm() {
            setFilterForm({})
        }
    }));


    useEffect(() => {
        if (lineForm.countedQuantity) {
            let qty = parseFloat(parseFloat(lineForm?.countedQuantity) - parseFloat(lineForm?.currentStock));
            let amt = lineForm.countedQuantity * lineForm.pricePerUnit;
            setLineForm({
                ...lineForm, quantity: qty, amount: amt
            });
        }
    }, [lineForm.countedQuantity]);


    const onEdit = (data, i, view = false) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        data.pricePerUnit = data?.pricePerUnit || 0;
        setLineForm(data);
        productApi('', data?.productId || '');
        handleUnits(data.product);
        const updatedBatches = data?.batchDetails?.map(el => ({
            ...el,
            currentStock: el?.availableStock,
            countedQuantity: el?.countedQuantity,
            stockCount: el?.stockCount,
        })) || [];
        setBatch(updatedBatches);
    }

    const onDelete = (data, i) => {
        setDeleteVisible(true);
        setLineId(i);
        setLineName(data?.product?.productName || '');
    }



    const handleProductChange = async (d) => {
        if (d?.id) {
            let data = {
                productId: d?.id,
                product: d
            }

            data['unitId'] = form?.unitId || d?.salesUnitId || '';
            data['unit'] = form?.unit || d.salesUnit || '';
            data['universalProductId'] = d.universalProductId;
            data['batchOverride'] = d?.batchActivation || false;

            if (locationDetails && locationDetails?.length > 0) {
                let a = locationDetails?.filter(el => el.default);
                if (a?.length) {
                    data.locationId = a[0]?.id;
                    data.location = a[0];
                } else {
                    data.locationId = locationDetails[0]?.id;
                    data.location = locationDetails[0];
                }
            }
            await getProductBatch(d?.id, data.locationId);
            let units = await handleUnits(d);
            getAvailableQty({ ...lineForm, ...data }, units);

        }
    }

    const getProductBatch = async (id, locationId) => {
        try {
            let f = { where: { ["and"]: [{ productId: id }, { locationId: locationId }] } };

            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${id}?filter=${encodeURIComponent(JSON.stringify(f))}`);
            const data = response.data;
            let val = [];

            if (data && data.length) {
                val = data.map((item) => {
                    const { id, ...rest } = item; // safely destructure
                    return {
                        ...rest,
                        batchId: id,
                        currentStock: item.availableStock,
                        countedQuantity: 0,
                        stockCount: batch.availableStock - 0 // assuming countedQuantity = 0 initially
                    };
                });
            } else {
                val = [];
            }
            setBatch(val);
            return val;
        } catch (error) {
            setBatch([]);
            return [];
        }
    }

    const handleBulkUnits = (products) => {
        // Initialize a map to collect unitIds per product
        const unitMap = {};
        products.forEach(p => {
            unitMap[p.id] = [p.salesUnitId, p.skuUnitId].filter(Boolean);
        });

        setUnits(prev => {
            const updated = { ...prev };
            Object.keys(unitMap).forEach(pid => {
                updated[pid] = unitMesurementdetails.filter(el => unitMap[pid].includes(el.id));
            });
            return updated;
        });
    };

    const getAvailableQty = async (lineForm, units = []) => {
        try {
            if (units?.length > 0) {
                if (!units.find(el => el.id === lineForm?.unitId)) {
                    lineForm.unit = lineForm?.product?.salesUnit || {};
                    lineForm.unitId = lineForm?.product?.salesUnitId || {};
                }
            }
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${lineForm?.productId}/${lineForm?.unitId}/${lineForm?.locationId}`);
            const data = response.data;
            let availableQty = 0; let costPrice = 0;
            if (data?.length && data[0]?.units?.length) {
                let qty = data[0]?.units.find(obj => obj.hasOwnProperty(lineForm?.unitId))?.[lineForm?.unitId];
                availableQty = parseFloat(parseFloat(qty).toFixed(2));
            }


            if (data?.length && data[0]?.cPrice?.length) {
                let qty = data[0]?.cPrice.find(obj => obj.hasOwnProperty(lineForm?.unitId))?.[lineForm?.unitId];
                costPrice = parseFloat(parseFloat(qty).toFixed(2));
            }

            setLineForm({
                ...lineForm,
                pricePerUnit: costPrice,
                currentStock: availableQty,
                amount: availableQty * costPrice,
                countedQuantity: availableQty
            });
        } catch (error) {
            console.log(error);
        }
    }

    // const handleUnits = (data) => {
    //     let filter = {
    //         where: {
    //             and: [{ productId: data?.id }, { or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId },] }]
    //         }
    //     }; let uFilter = {
    //         where: {
    //             or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId }]
    //         }
    //     };
    //     let a = [data?.salesUnitId, data?.skuUnitId];

    //     getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
    //         .then(response => {
    //             let data = response.data;
    //             if (data && data.length > 0) {
    //                 data.forEach(el => {
    //                     a.push(el.unitId)
    //                     a.push(el.toUnitId);
    //                 });
    //             }
    //             return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
    //         }).then(uResponse => {
    //             let uData = uResponse.data;
    //             if (uData && uData.length > 0) {
    //                 uData.forEach(el => {
    //                     a.push(el.unitId)
    //                     a.push(el.toUnitId)
    //                 });
    //             }
    //             const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
    //             setUnits(prev => {
    //                 return {
    //                     ...prev,
    //                     [data?.id]: filtered  // Append `filtered` array
    //                 };
    //             });
    //         })
    //         .catch(error => {
    //             console.error("Error fetching data", error);
    //         });
    // }

    const handleUnits = async (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId }]
            }
        };

        let a = [data?.salesUnitId, data?.skuUnitId];

        // 🔥 await first API
        const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter),)}`,);

        if (response?.data?.length) {
            response.data.forEach(el => {
                a.push(el.unitId);
                a.push(el.toUnitId);
            });
        }

        // 🔥 await second API
        const uResponse = await getRequest(
            `${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(
                JSON.stringify(uFilter),
            )}`,
        );

        if (uResponse?.data?.length) {
            uResponse.data.forEach(el => {
                a.push(el.unitId);
                a.push(el.toUnitId);
            });
        }

        const filtered = unitMesurementdetails.filter(el => a.includes(el.id));

        // keep state update if you need it
        setUnits(prev => ({
            ...prev,
            [data?.id]: filtered,
        }));

        return filtered;
    };

    const changeHandler = async (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'unit': e
                });
                getAvailableQty({
                    ...lineForm,
                    [name]: e.id,
                    'unit': e
                });
            } else if (name === 'locationId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
                await getProductBatch(lineForm?.productId, e.id);
                getAvailableQty({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
            } else {
                setLineForm({
                    ...lineForm,
                    [name]: e
                });
            }
        } else {
            setLineForm({
                ...lineForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const handleQuantityChange = (value) => {
        if (lineForm?.productId && value) {
            if (priceRef.current !== null) {
                clearTimeout(priceRef.current);
            }
            priceRef.current = setTimeout(() => {
                priceRef.current = null;
                dispatch({
                    type: productActions.PRODUCT_PRICE_START,
                    url: `/saledprice/${form?.customerId}/${lineForm?.productId}/${value}`
                });
            }, 500);
        }
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyProduct = emptyValidation('Product', lineForm?.productId, 'dropDown');
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Counted Quantity', lineForm?.countedQuantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);

        let batchQuantityError = { isValid: true, errors: '' };

        if (lineForm?.batchOverride && batch.length === 0) {
            batchQuantityError = { isValid: false, errors: "Please enter Batch Details" }
        }

        if (batch.length > 0 && lineForm?.batchOverride) {
            let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.stockCount || 0)), 0);

            //let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.quantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
            }

            const emptyBatchNumbers = batch?.filter(item => !item.batchNumber);
            if (emptyBatchNumbers?.length) {
                batchQuantityError = { isValid: false, errors: "Batch Number Can't be blank" }
            }
        }

        if (lineId === '' && lineForm?.productId && lines.some(line => line.productId === lineForm?.productId)) {
            emptyProduct = { isValid: false, errors: `Product already exists in Line "${lineId}". Go to Line "${lineId}" to update the quantity.` };
        }

        setLineError({});
        if (emptyProduct.isValid && emptyUnit.isValid && emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && batchQuantityError.isValid) {
            lineForm.quantity = parseFloat(lineForm.quantity);
            if (batch?.length > 0) {
                let aL = [];
                batch?.map((element, i) => {
                    if (element?.batchNumber !== '') {
                        let amount = parseFloat(parseFloat(element?.stockCount || 0) * parseFloat(lineForm?.pricePerUnit || 0));
                        element.perUnitPrice = lineForm?.pricePerUnit || 0;
                        element.currentStock = parseFloat(element?.currentStock || 0);
                        element.countedQuantity = parseFloat(element?.countedQuantity || 0);
                        element.stockCount = parseFloat(element?.stockCount || 0);
                        element.mrp = lineForm?.product?.mrp || 0;
                        element.unitId = lineForm?.unitId;
                        element.purchasePrice = amount - parseFloat(element?.discountAmount || 0);
                        element.businessId = getBusinessId();
                        if (lineForm?.productId) element.productId = lineForm?.productId
                        return aL.push(element)
                    }
                });
                lineForm["batchDetails"] = lineForm?.batchOverride ? aL : [];
            }
            lineSubmit(lineForm, lineId);
            handleOpen();
            if (more) {
                setTimeout(function () {
                    addLineRef.current.click();
                }, 500)
            }
            setLineId('');
        } else {
            setLineError({
                productId: emptyProduct?.errors || false,
                unitId: emptyUnit?.errors || false,
                pricePerUnit: emptyPrice?.errors || false,
                countedQuantity: emptyQuantity?.errors || false,
                batchQuantity: batchQuantityError?.errors || false
            })
        }
    }

    const handleKeyDown = (e) => {
        if (!headerView && e.altKey && e.keyCode === 76) {
            e.preventDefault();
            if (form?.customerId) {
                handleOpen();
            } else {
                toast.dismiss();
                toast.error('Please select customer then add lines.');
            }
        }
    };

    const handleBulkLines = () => {
        setFilterVisible(!filterVisible);
        productApi();
        productGroupApi();
    }

    const changeFilterHandler = (e, name) => {
        setFilterForm({
            ...filterForm,
            [name]: e
        })
    }

    const loadImportExportData = (data) => {
        exportCommonFile(data, lines);
    }

    useEventListener("keydown", handleKeyDown);

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;


    return (
        <>
            <Row>
                <Col xxl={8} xl={9} lg={10} md={12} sm={16} xs={24}>
                    <div className={clsx(classes.dropDownWithSearch, classes.customerLabelNone)}>
                        <AutoCompleteComponent
                            customLabel={"Type"}
                            heads={[{ 'key': 'label', 'name': 'Search Configuration' }]}
                            details={searchTypes}
                            parentValue={customObject(searchTypes, searchType)}
                            position={"bottom"}
                            variant={'outlined'}
                            onChange={(data) => changeSearchType(data.id)}
                        />
                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                            <TextField autoComplete='one-time-code'
                                placeholder={
                                    searchType === 'standard' ? 'Search Product Name & ID, Bar Code, Code, Unit, Location' :
                                        searchType === 'both' ? 'Search Name, and Code' :
                                            searchType === 'name' ? 'Search Name' :
                                                searchType === 'code' ? 'Search Code' :
                                                    searchType === 'mrp' ? 'Search MRP' : ''
                                }
                                type='search'
                                value={search}
                                id={idNamingConversion('Search', 'stockCount', 'TextField')}
                                onChange={(e) => setSearch(e.target.value)}
                                className={classes.comInput}
                                variant={'standard'}
                                fullWidth
                                onFocus={() => setIconAnimation(true)}
                                onBlur={() => setIconAnimation(false)}
                            />
                            <Image
                                src={SearchIcon}
                                preview={false}
                            />
                            {
                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                    <Image
                                        src={ClearIcon}
                                        preview={false}
                                    />
                                </NavLink>
                            }
                        </div>
                    </div>
                </Col>
                <Col xxl={16} xl={15} lg={14} md={12} sm={8} xs={24} className={classes.textAlignRight}>
                    <Space direction="horizontal" align="center" size={[10, 10]}>
                        {
                            selected?.length > 0 ? <NavLink to={'#'} onClick={() => { handleBulkDelete(selected) }} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Bulk Delete</span>
                            </NavLink> : null
                        }
                        {
                            lines?.length > 0 ? <NavLink to={'#'} onClick={() => { loadImportExportData('Stock Count Lines') }} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                            </NavLink> : null
                        }
                        {
                            !headerView && locationDetails && locationDetails?.length > 0 && <>
                                <NavLink to={'#'} onClick={() => handleBulkLines()} className={clsx(classes.customLink, classes.disInline)}>
                                    <Image
                                        src={AddIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Stock Count Lines</span>
                                </NavLink>
                                {
                                    !headerView &&
                                    <NavLink to={'#'} ref={addLineRef} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                        <Image
                                            src={AddIcon}
                                            preview={false}
                                            className={clsx(classes.antImage)}
                                        /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                                    </NavLink>
                                }
                            </>
                        }
                    </Space>
                </Col>
            </Row>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    loadMore={true}
                    loadMoreContent={false}
                    heads={headerView ? countLineHead.filter(item => item.key !== 'checkbox') : countLineHead}
                    width={true}
                    autoWidth={true}
                    selected={selected}
                    details={lines}
                    onSelected={(value) => setSelected(value)}
                    keyValue={'lineNumber'}
                    component={
                        <>
                            {
                                lines?.length > 0 ? lines.map((data, i) => (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                        {
                                            headerView ? '' : <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(e, data.lineNumber)} padding="checkbox">
                                                <Checkbox color="primary" checked={isSelected(data.lineNumber)} />
                                            </TableCell>
                                        }
                                        <TableCell style={{ width: 10 }}>{i + 1}</TableCell>
                                        <TableCell style={{ width: getColumnWidth(countLineHead, 1) }}><NavLink style={{ width: getColumnWidth(countLineHead, 1) }} to={"#"} className={clsx(classes.bold, classes.color)} onClick={() => onEdit(data, i, true)}><span className={classes.descEllipsis}>{data?.product?.productName || ''}</span></NavLink></TableCell>
                                        <TableCell style={{ width: getColumnWidth(countLineHead, 2) }}><span style={{ width: getColumnWidth(countLineHead, 2) }}>{data?.product?.productId || '---'}</span></TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.stockCountLineUnit)}>
                                            {data?.unit?.name || '---'}
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.stockCountLineUnit)}>
                                            {data?.currentStock || 0}
                                        </TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                            {
                                                headerView ? data?.countedQuantity :
                                                    <TextField autoComplete='one-time-code'
                                                        fullWidth
                                                        style={{ width: "100%", maxWidth: "none" }}
                                                        className={clsx(classes.storeSalesLineQuantity)}
                                                        value={data?.countedQuantity || ''}
                                                        type={'number'}
                                                        InputProps={{
                                                            classes: {
                                                                input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textAreaLableColorCustom,
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        id={idNamingConversion('Counted Quantity_' + i, 'stockCountLine', 'TextField')}
                                                        onWheel={(e) => e.target.blur()}
                                                        onFocus={(e) => {
                                                            e.target.select();
                                                        }}
                                                        onChange={(e) => changeHandlerLine(data, e.target.value, 'countedQuantity')}
                                                    />
                                            }
                                        </TableCell>
                                        {/* <TableCell className={clsx(classes.storeSalesLineCell)}>
                                            {data?.quantity || '---'}
                                        </TableCell> */}
                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignRight)}>
                                            {`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.stockCountLineUnit)}>
                                            {data?.location?.name || '---'}
                                        </TableCell>
                                        <TableCell className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                <NavLink to={"#"} onClick={() => onEdit(data, i, true)}>
                                                    <Image
                                                        src={ViewIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                                {
                                                    !headerView && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                        <Image
                                                            src={EditIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                                {
                                                    !headerView &&
                                                    <NavLink to={"#"} onClick={() => onDelete(data, i)}>
                                                        <Image
                                                            src={DeleteIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </Space>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ textAlign: "center" }} colSpan={10}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your stock'}</p>
                                    </TableCell>
                                </TableRow>
                            }
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Stock Count Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <LineForm {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        units={units}
                        headerView={headerView}
                        handleAddMore={(e) => handleAddMore(e)}
                        lineError={lineError}
                        handleEdit={(v) => setView(v)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        handleQuantityChange={(v) => handleQuantityChange(v)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        handleProductChange={(data) => handleProductChange(data)}
                    />
                }
            />

            <RunQuery
                {...props}
                visible={filterVisible}
                handleClose={() => setFilterVisible(!filterVisible)}
                createProduct={(filterForm) => createProduct(filterForm)}
                changeHandler={(e, name) => changeFilterHandler(e, name)}
                form={filterForm}
                productApi={(s = '', id = '') => productApi(s, id)}
            />

            <Modal
                title={'Delete Confirmation'}
                open={deleteVisible}
                onOk={() => setDeleteVisible(false)}
                onCancel={() => setDeleteVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => { setDeleteVisible(false); deleteLine(lineId) }}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setDeleteVisible(false)}>
                        No
                    </Button>,
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineName}</p>
            </Modal>
        </>
    )
})